import { Button, Spacer, VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { useTypographyStore } from "@redux/slices/typographySlice";
import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import styled, { useTheme } from "styled-components/native";
import { EmptyViewProps } from "./types";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { SpaceType } from "@components/atoms/Spacer/types";
import { VDBIcons } from "@utils/VDBIcons";
import { setSectionName } from "@redux/slices/searchFilters";
import { useDispatch } from "react-redux";
import { setProductType } from "@redux/slices/appStateSlice";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { fallbackIfEmptyDeeplink } from "@scenes/favorites/utils/FavoritesUtils";

const EmptyView = (props: EmptyViewProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const typography = useTypographyStore();
  const userInfo = useUserInfo();
  const dispatch = useDispatch();
  const navigateToExplore = () => {
    if (theme.isLargeScreen) {
      dispatch(setSectionName(""));
      dispatch(setProductType(""));
    }
    fallbackIfEmptyDeeplink(userInfo, dispatch, theme);
  };

  return (
    <Overlay>
      <View>
        <VDBIcon
          color={theme["core-03"]}
          name={VDBIcons.REQUEST_HISTORY}
          size={64}
          variant={IconsVariant.VDBCustom}
        />
      </View>
      <Spacer size={SpaceType.Double} />
      <TextContainer>
        <VDBText color={theme["core-05"]} type={typography["H3-M"]}>
          {t(props.emptyTitle)}
        </VDBText>
      </TextContainer>
      <Spacer size={SpaceType.Basic} />
      <SubTextContainer>
        <VDBText
          color={theme["core-06"]}
          type={typography["Body-R"]}
          textAlign="center"
        >
          {t(props.emptyDescription)}
        </VDBText>
      </SubTextContainer>
      <Spacer size={SpaceType.ExtraLarge} />
      <ButtonContainer>
        {props.showButton && (
          <Button
            type={ButtonType.primary}
            category={ButtonCategory.default}
            title={t("requestHistory.empryStateButton.text")}
            onPress={navigateToExplore}
            textTypographyStyle="H3-M"
          />
        )}
      </ButtonContainer>
    </Overlay>
  );
};

const Overlay = styled.View`
  flex: 1;
  justify-content: center;
  padding-bottom: 60px;
  align-items: center;
  padding-horizontal: ${SpaceType.Double}px;
  width: 100%;
`;

const TextContainer = styled.View`
  max-width: 320px;
`;

const ButtonContainer = styled.View`
  width: 100%;
  max-width: 320px;
  justify-content: center;
`;

const SubTextContainer = styled.View`
  max-width: 320px;
`;

export default EmptyView;
